/*
 * etee custom JavaScript.
 * Ported from the live theme's assets/custom.js (the debug console logging was removed).
 * Loaded from snippets/etee-body-end.liquid.
 */

(function () {
  // Reviews modal: open on ".read-reviews-text", close on the close button or backdrop.
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.read-reviews-text');
    if (trigger) {
      const productId = trigger.getAttribute('data-product-id');
      const modal = document.getElementById('reviews-modal-' + productId);
      if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    }

    const closeBtn = event.target.closest('.reviews-modal-close');
    if (closeBtn) {
      const productId = closeBtn.id.replace('close-reviews-', '');
      const modal = document.getElementById('reviews-modal-' + productId);
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }

    if (event.target.classList.contains('reviews-modal-backdrop')) {
      const modal = event.target.closest('.reviews-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });

  // Close any open reviews modal with Escape.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.reviews-modal[style*="block"]').forEach(function (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
  });

  // Sound toggle for autoplay videos (".video-autoplay-wrapper" with a ".video-sound-toggle" button).
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.video-autoplay-wrapper').forEach(function (wrapper) {
      let videoElement = wrapper.querySelector('video');

      if (!videoElement) {
        const iframe = wrapper.querySelector('iframe');
        if (iframe && iframe.contentDocument) {
          videoElement = iframe.contentDocument.querySelector('video');
        }
      }

      if (!videoElement) {
        videoElement = wrapper.querySelector('.video-toggle-target');
      }

      if (!videoElement) {
        videoElement = wrapper.querySelector('[autoplay], [muted], [playsinline]');
      }

      const toggleButton = wrapper.querySelector('.video-sound-toggle');
      if (!videoElement || !toggleButton) return;

      videoElement.play().catch(function () {});

      toggleButton.addEventListener('click', function () {
        videoElement.muted = !videoElement.muted;

        const volumeOffIcon = toggleButton.querySelector('.icon-volume-off');
        const volumeOnIcon = toggleButton.querySelector('.icon-volume-on');
        if (volumeOffIcon && volumeOnIcon) {
          volumeOffIcon.style.display = videoElement.muted ? '' : 'none';
          volumeOnIcon.style.display = videoElement.muted ? 'none' : '';
        }
      });
    });
  });
})();

(function () {
  // Header account menu in the mobile drawer (snippets/etee-header-account.liquid):
  // the account icon opens and closes the Account / Subscriptions / Rewards links.
  // Ported from the inline script in live's sections/header.liquid.
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-etee-account-toggle]');
    if (!toggle) return;

    const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!submenu) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    submenu.classList.toggle('display-none', expanded);
  });
})();
